"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _languageSelectorModule = _interopRequireDefault(require("./language-selector.module.scss"));
var _Select = require("../../elements/select/select/Select");
var _reactI18next = require("react-i18next");
var languages = [{
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _languageSelectorModule.default['language-selector__span']
  }, 'English')),
  value: 'EN'
}, {
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _languageSelectorModule.default['language-selector__span']
  }, 'Español')),
  value: 'ES'
}, {
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _languageSelectorModule.default['language-selector__span']
  }, 'Français')),
  value: 'FR'
}, {
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _languageSelectorModule.default['language-selector__span']
  }, 'Nederlands')),
  value: 'NL'
}, {
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _languageSelectorModule.default['language-selector__span']
  }, 'Polski')),
  value: 'PL'
}];
var LanguageSelector = function LanguageSelector(_ref) {
  var value = _ref.value,
    changeBackgroundColor = _ref.changeBackgroundColor,
    isNavigation = _ref.isNavigation;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    i18n = _useTranslation.i18n;
  var language = localStorage.getItem('language');
  var changeLanguage = function changeLanguage(language) {
    i18n.changeLanguage(language.toLowerCase());
    window.dispatchEvent(new Event('storage'));
  };
  (0, _react.useEffect)(function () {
    //Runs only on the first render
    if (language) {
      changeLanguage(language);
    }
  }, []);
  var handleLanguageChange = function handleLanguageChange(e) {
    localStorage.setItem('language', e.currentTarget.value);
    changeLanguage(e.currentTarget.value);
  };
  var navigationStyle = isNavigation ? 'language-selector-navigation' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _languageSelectorModule.default['language-selector']
  }, /*#__PURE__*/_react.default.createElement(_Select.Select, {
    id: 'languageSelector',
    name: 'languageSelector',
    className: _languageSelectorModule.default[navigationStyle],
    options: languages,
    onChange: handleLanguageChange,
    value: value,
    styleMenu: true,
    styleControl: changeBackgroundColor
  }));
};
exports.LanguageSelector = LanguageSelector;